import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType"
import { AssignmentSubmission } from "../types/assignmentSubmission";

const assignmentSubmissionApis = {
  getSubmissionsByAssignmentId: async (
    assignmentId: string
  ): Promise<ApiResponse<AssignmentSubmission[]>> => {
    const response = await customFetch.get(
      `/api/v1/assignment-submissions/assignment/${assignmentId}`
    );

    return response.data;
  },
};

export default assignmentSubmissionApis;
